import { Button } from '@/components/ui/button'
import { useBusinessEntity } from '@/hooks/business-entity'
import { buildPath } from '@/routes'
import { PlusIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

interface TicketOpenButtonProps {
  businessEntityId?: string
}

export function TicketOpenButton({ businessEntityId }: TicketOpenButtonProps) {
  const { selectBusinessEntity } = useBusinessEntity()
  const navigate = useNavigate()

  const openTicket = () => {
    if (businessEntityId) selectBusinessEntity(businessEntityId)
    navigate(buildPath('/tickets/new'))
  }

  return (
    <Button onClick={openTicket}>
      <PlusIcon />
      Open a Ticket
    </Button>
  )
}
